import { Currency } from './currencies.ts'

import type { Country } from '../types/country.ts'

/* eslint-disable max-lines */
export enum CountryIso2Code {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

export const EU_COUNTRIES_ISO2_CODE = new Set<string>([
  CountryIso2Code.AT,
  CountryIso2Code.BE,
  CountryIso2Code.BG,
  CountryIso2Code.CY,
  CountryIso2Code.CZ,
  CountryIso2Code.DE,
  CountryIso2Code.DK,
  CountryIso2Code.EE,
  CountryIso2Code.ES,
  CountryIso2Code.FI,
  CountryIso2Code.FR,
  CountryIso2Code.GR,
  CountryIso2Code.HR,
  CountryIso2Code.HU,
  CountryIso2Code.IE,
  CountryIso2Code.IT,
  CountryIso2Code.LT,
  CountryIso2Code.LU,
  CountryIso2Code.LV,
  CountryIso2Code.MT,
  CountryIso2Code.NL,
  CountryIso2Code.PL,
  CountryIso2Code.PT,
  CountryIso2Code.RO,
  CountryIso2Code.SE,
  CountryIso2Code.SI,
  CountryIso2Code.SK,
])

export const COUNTRIES: Record<string, Country> = {
  AD: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '376',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AD.png',
    iso2: 'AD',
    name: 'Andorra',
    priority: 0,
    timezone: 'Europe/Andorra',
  },
  AE: {
    areaCodes: null,
    currency: Currency.AED,
    dialCode: '971',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AE.png',
    iso2: 'AE',
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    priority: 0,
    timezone: 'Asia/Dubai',
  },
  AF: {
    areaCodes: null,
    currency: Currency.AFN,
    dialCode: '93',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AF.png',
    iso2: 'AF',
    name: 'Afghanistan (‫افغانستان‬‎)',
    priority: 0,
    timezone: 'Asia/Kabul',
  },
  AG: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1268',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AG.png',
    iso2: 'AG',
    name: 'Antigua and Barbuda',
    priority: 0,
    timezone: 'America/Antigua',
  },
  AI: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1264',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AI.png',
    iso2: 'AI',
    name: 'Anguilla',
    priority: 0,
    timezone: 'America/Anguilla',
  },
  AL: {
    areaCodes: null,
    currency: Currency.ALL,
    dialCode: '355',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AL.png',
    iso2: 'AL',
    name: 'Albania (Shqipëri)',
    priority: 0,
    timezone: 'Europe/Tirane',
  },
  AM: {
    areaCodes: null,
    currency: Currency.AMD,
    dialCode: '374',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AM.png',
    iso2: 'AM',
    name: 'Armenia (Հայաստան)',
    priority: 0,
    timezone: 'Asia/Yerevan',
  },
  AO: {
    areaCodes: null,
    currency: Currency.AOA,
    dialCode: '244',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AO.png',
    iso2: 'AO',
    name: 'Angola',
    priority: 0,
    timezone: 'Africa/Luanda',
  },
  AR: {
    areaCodes: null,
    currency: Currency.ARS,
    dialCode: '54',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AR.png',
    iso2: 'AR',
    name: 'Argentina',
    priority: 0,
    timezone: 'America/Argentina/Cordoba',
  },
  AS: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1684',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AS.png',
    iso2: 'AS',
    name: 'American Samoa',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  AT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '43',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AT.png',
    iso2: 'AT',
    name: 'Austria (Österreich)',
    priority: 0,
    timezone: 'Europe/Vienna',
  },
  AU: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AU.png',
    iso2: 'AU',
    name: 'Australia',
    priority: 0,
    timezone: 'Australia/Darwin',
  },
  AW: {
    areaCodes: null,
    currency: Currency.AWG,
    dialCode: '297',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AW.png',
    iso2: 'AW',
    name: 'Aruba',
    priority: 0,
    timezone: 'America/Aruba',
  },
  AX: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '358',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AX.png',
    iso2: 'AX',
    name: 'Åland Islands',
    priority: 1,
    timezone: 'Europe/Helsinki',
  },
  AZ: {
    areaCodes: null,
    currency: Currency.AZN,
    dialCode: '994',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/AZ.png',
    iso2: 'AZ',
    name: 'Azerbaijan (Azərbaycan)',
    priority: 0,
    timezone: 'Asia/Baku',
  },
  BA: {
    areaCodes: null,
    currency: Currency.BAM,
    dialCode: '387',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BA.png',
    iso2: 'BA',
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    priority: 0,
    timezone: 'Europe/Sarajevo',
  },
  BB: {
    areaCodes: null,
    currency: Currency.BBD,
    dialCode: '1246',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BB.png',
    iso2: 'BB',
    name: 'Barbados',
    priority: 0,
    timezone: 'America/Barbados',
  },
  BD: {
    areaCodes: null,
    currency: Currency.BDT,
    dialCode: '880',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BD.png',
    iso2: 'BD',
    name: 'Bangladesh (বাংলাদেশ)',
    priority: 0,
    timezone: 'Asia/Dhaka',
  },
  BE: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '32',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BE.png',
    iso2: 'BE',
    name: 'Belgium (België)',
    priority: 0,
    timezone: 'Europe/Brussels',
  },
  BF: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '226',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BF.png',
    iso2: 'BF',
    name: 'Burkina Faso',
    priority: 0,
    timezone: 'Africa/Ouagadougou',
  },
  BG: {
    areaCodes: null,
    currency: Currency.BGN,
    dialCode: '359',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BG.png',
    iso2: 'BG',
    name: 'Bulgaria (България)',
    priority: 0,
    timezone: 'Europe/Sofia',
  },
  BH: {
    areaCodes: null,
    currency: Currency.BHD,
    dialCode: '973',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BH.png',
    iso2: 'BH',
    name: 'Bahrain (‫البحرين‬‎)',
    priority: 0,
    timezone: 'Asia/Bahrain',
  },
  BI: {
    areaCodes: null,
    currency: Currency.BIF,
    dialCode: '257',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BI.png',
    iso2: 'BI',
    name: 'Burundi (Uburundi)',
    priority: 0,
    timezone: 'Africa/Bujumbura',
  },
  BJ: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '229',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BJ.png',
    iso2: 'BJ',
    name: 'Benin (Bénin)',
    priority: 0,
    timezone: 'Africa/Porto-Novo',
  },
  BL: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BL.png',
    iso2: 'BL',
    name: 'Saint Barthélemy',
    priority: 1,
    timezone: 'America/St_Barthelemy',
  },
  BM: {
    areaCodes: null,
    currency: Currency.BMD,
    dialCode: '1441',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BM.png',
    iso2: 'BM',
    name: 'Bermuda',
    priority: 0,
    timezone: 'Atlantic/Bermuda',
  },
  BN: {
    areaCodes: null,
    currency: Currency.BND,
    dialCode: '673',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BN.png',
    iso2: 'BN',
    name: 'Brunei',
    priority: 0,
    timezone: 'Asia/Brunei',
  },
  BO: {
    areaCodes: null,
    currency: Currency.BOB,
    dialCode: '591',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BO.png',
    iso2: 'BO',
    name: 'Bolivia',
    priority: 0,
    timezone: 'America/La_Paz',
  },
  BQ: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '599',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BQ.png',
    iso2: 'BQ',
    name: 'Caribbean Netherlands',
    priority: 1,
    timezone: 'America/Kralendijk',
  },
  BR: {
    areaCodes: null,
    currency: Currency.BRL,
    dialCode: '55',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BR.png',
    iso2: 'BR',
    name: 'Brazil (Brasil)',
    priority: 0,
    timezone: 'America/Cuiaba',
  },
  BS: {
    areaCodes: null,
    currency: Currency.BSD,
    dialCode: '1242',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BS.png',
    iso2: 'BS',
    name: 'Bahamas',
    priority: 0,
    timezone: 'America/Nassau',
  },
  BT: {
    areaCodes: null,
    currency: Currency.BTN,
    dialCode: '975',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BT.png',
    iso2: 'BT',
    name: 'Bhutan (འབྲུག)',
    priority: 0,
    timezone: 'Asia/Thimphu',
  },
  BW: {
    areaCodes: null,
    currency: Currency.BWP,
    dialCode: '267',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BW.png',
    iso2: 'BW',
    name: 'Botswana',
    priority: 0,
    timezone: 'Africa/Gaborone',
  },
  BY: {
    areaCodes: null,
    currency: Currency.BYN,
    dialCode: '375',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BY.png',
    iso2: 'BY',
    name: 'Belarus (Беларусь)',
    priority: 0,
    timezone: 'Europe/Minsk',
  },
  BZ: {
    areaCodes: null,
    currency: Currency.BZD,
    dialCode: '501',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/BZ.png',
    iso2: 'BZ',
    name: 'Belize',
    priority: 0,
    timezone: 'America/Belize',
  },
  CA: {
    areaCodes: [
      '204',
      '226',
      '236',
      '249',
      '250',
      '289',
      '306',
      '343',
      '365',
      '387',
      '403',
      '416',
      '418',
      '431',
      '437',
      '438',
      '450',
      '506',
      '514',
      '519',
      '548',
      '579',
      '581',
      '587',
      '604',
      '613',
      '639',
      '647',
      '672',
      '705',
      '709',
      '742',
      '778',
      '780',
      '782',
      '807',
      '819',
      '825',
      '867',
      '873',
      '902',
      '905',
    ],
    currency: Currency.CAD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CA.png',
    iso2: 'CA',
    name: 'Canada',
    priority: 1,
    timezone: 'America/Rankin_Inlet',
  },
  CC: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CC.png',
    iso2: 'CC',
    name: 'Cocos (Keeling) Islands',
    priority: 1,
    timezone: 'Indian/Cocos',
  },
  CD: {
    areaCodes: null,
    currency: Currency.CDF,
    dialCode: '243',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CD.png',
    iso2: 'CD',
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    priority: 0,
    timezone: 'Africa/Lubumbashi',
  },
  CF: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '236',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CF.png',
    iso2: 'CF',
    name: 'Central African Republic (République centrafricaine)',
    priority: 0,
    timezone: 'Africa/Bangui',
  },
  CG: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '242',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CG.png',
    iso2: 'CG',
    name: 'Congo (Republic) (Congo-Brazzaville)',
    priority: 0,
    timezone: 'Africa/Brazzaville',
  },
  CH: {
    areaCodes: null,
    currency: Currency.CHF,
    dialCode: '41',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CH.png',
    iso2: 'CH',
    name: 'Switzerland (Schweiz)',
    priority: 0,
    timezone: 'Europe/Zurich',
  },
  CI: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '225',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CI.png',
    iso2: 'CI',
    name: 'Côte d’Ivoire',
    priority: 0,
    timezone: 'Africa/Abidjan',
  },
  CK: {
    areaCodes: null,
    currency: Currency.NZD,
    dialCode: '682',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CK.png',
    iso2: 'CK',
    name: 'Cook Islands',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  CL: {
    areaCodes: null,
    currency: Currency.CLP,
    dialCode: '56',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CL.png',
    iso2: 'CL',
    name: 'Chile',
    priority: 0,
    timezone: 'America/Santiago',
  },
  CM: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '237',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CM.png',
    iso2: 'CM',
    name: 'Cameroon (Cameroun)',
    priority: 0,
    timezone: 'Africa/Douala',
  },
  CN: {
    areaCodes: null,
    currency: Currency.CNY,
    dialCode: '86',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CN.png',
    iso2: 'CN',
    name: 'China (中国)',
    priority: 0,
    timezone: 'Asia/Shanghai',
  },
  CO: {
    areaCodes: null,
    currency: Currency.COP,
    dialCode: '57',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CO.png',
    iso2: 'CO',
    name: 'Colombia',
    priority: 0,
    timezone: 'America/Bogota',
  },
  CR: {
    areaCodes: null,
    currency: Currency.CRC,
    dialCode: '506',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CR.png',
    iso2: 'CR',
    name: 'Costa Rica',
    priority: 0,
    timezone: 'America/Costa_Rica',
  },
  CU: {
    areaCodes: null,
    currency: Currency.CUP,
    dialCode: '53',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CU.png',
    iso2: 'CU',
    name: 'Cuba',
    priority: 0,
    timezone: 'America/Havana',
  },
  CV: {
    areaCodes: null,
    currency: Currency.CVE,
    dialCode: '238',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CV.png',
    iso2: 'CV',
    name: 'Cape Verde (Kabu Verdi)',
    priority: 0,
    timezone: 'Atlantic/Cape_Verde',
  },
  CW: {
    areaCodes: null,
    currency: Currency.ANG,
    dialCode: '599',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CW.png',
    iso2: 'CW',
    name: 'Curaçao',
    priority: 0,
    timezone: 'America/Curacao',
  },
  CX: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '61',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CX.png',
    iso2: 'CX',
    name: 'Christmas Island',
    priority: 2,
    timezone: 'Indian/Christmas',
  },
  CY: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '357',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CY.png',
    iso2: 'CY',
    name: 'Cyprus (Κύπρος)',
    priority: 0,
    timezone: 'Asia/Nicosia',
  },
  CZ: {
    areaCodes: null,
    currency: Currency.CZK,
    dialCode: '420',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/CZ.png',
    iso2: 'CZ',
    name: 'Czech Republic (Česká republika)',
    priority: 0,
    timezone: 'Europe/Prague',
  },
  DE: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '49',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DE.png',
    iso2: 'DE',
    name: 'Germany (Deutschland)',
    priority: 0,
    timezone: 'Europe/Berlin',
  },
  DJ: {
    areaCodes: null,
    currency: Currency.DJF,
    dialCode: '253',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DJ.png',
    iso2: 'DJ',
    name: 'Djibouti',
    priority: 0,
    timezone: 'Africa/Djibouti',
  },
  DK: {
    areaCodes: null,
    currency: Currency.DKK,
    dialCode: '45',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DK.png',
    iso2: 'DK',
    name: 'Denmark (Danmark)',
    priority: 0,
    timezone: 'Europe/Copenhagen',
  },
  DM: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1767',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DM.png',
    iso2: 'DM',
    name: 'Dominica',
    priority: 0,
    timezone: 'America/Dominica',
  },
  DO: {
    areaCodes: ['809', '829', '849'],
    currency: Currency.DOP,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DO.png',
    iso2: 'DO',
    name: 'Dominican Republic (República Dominicana)',
    priority: 2,
    timezone: 'America/Santo_Domingo',
  },
  DZ: {
    areaCodes: null,
    currency: Currency.DZD,
    dialCode: '213',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/DZ.png',
    iso2: 'DZ',
    name: 'Algeria (‫الجزائر‬‎)',
    priority: 0,
    timezone: 'Africa/Algiers',
  },
  EC: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '593',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EC.png',
    iso2: 'EC',
    name: 'Ecuador',
    priority: 0,
    timezone: 'America/Guayaquil',
  },
  EE: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '372',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EE.png',
    iso2: 'EE',
    name: 'Estonia (Eesti)',
    priority: 0,
    timezone: 'Europe/Tallinn',
  },
  EG: {
    areaCodes: null,
    currency: Currency.EGP,
    dialCode: '20',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EG.png',
    iso2: 'EG',
    name: 'Egypt (‫مصر‬‎)',
    priority: 0,
    timezone: 'Africa/Cairo',
  },
  EH: {
    areaCodes: null,
    currency: Currency.MAD,
    dialCode: '212',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/EH.png',
    iso2: 'EH',
    name: 'Western Sahara (‫الصحراء الغربية‬‎)',
    priority: 1,
    timezone: 'Africa/El_Aaiun',
  },
  ER: {
    areaCodes: null,
    currency: Currency.ERN,
    dialCode: '291',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ER.png',
    iso2: 'ER',
    name: 'Eritrea',
    priority: 0,
    timezone: 'Africa/Asmara',
  },
  ES: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '34',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ES.png',
    iso2: 'ES',
    name: 'Spain (España)',
    priority: 0,
    timezone: 'Europe/Madrid',
  },
  ET: {
    areaCodes: null,
    currency: Currency.ETB,
    dialCode: '251',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ET.png',
    iso2: 'ET',
    name: 'Ethiopia',
    priority: 0,
    timezone: 'Africa/Addis_Ababa',
  },
  FI: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '358',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FI.png',
    iso2: 'FI',
    name: 'Finland (Suomi)',
    priority: 0,
    timezone: 'Europe/Helsinki',
  },
  FJ: {
    areaCodes: null,
    currency: Currency.FJD,
    dialCode: '679',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FJ.png',
    iso2: 'FJ',
    name: 'Fiji',
    priority: 0,
    timezone: 'Pacific/Fiji',
  },
  FK: {
    areaCodes: null,
    currency: Currency.FKP,
    dialCode: '500',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FK.png',
    iso2: 'FK',
    name: 'Falkland Islands (Islas Malvinas)',
    priority: 0,
    timezone: 'Atlantic/Stanley',
  },
  FM: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '691',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FM.png',
    iso2: 'FM',
    name: 'Micronesia',
    priority: 0,
    timezone: 'Etc/GMT-10',
  },
  FO: {
    areaCodes: null,
    currency: Currency.DKK,
    dialCode: '298',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FO.png',
    iso2: 'FO',
    name: 'Faroe Islands (Føroyar)',
    priority: 0,
    timezone: 'Atlantic/Faroe',
  },
  FR: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '33',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/FR.png',
    iso2: 'FR',
    name: 'France',
    priority: 0,
    timezone: 'Europe/Paris',
  },
  GA: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '241',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GA.png',
    iso2: 'GA',
    name: 'Gabon',
    priority: 0,
    timezone: 'Africa/Libreville',
  },
  GB: {
    areaCodes: null,
    currency: Currency.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GB.png',
    iso2: 'GB',
    name: 'United Kingdom',
    priority: 0,
    timezone: 'Etc/GMT',
  },
  GD: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1473',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GD.png',
    iso2: 'GD',
    name: 'Grenada',
    priority: 0,
    timezone: 'America/Grenada',
  },
  GE: {
    areaCodes: null,
    currency: Currency.GEL,
    dialCode: '995',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GE.png',
    iso2: 'GE',
    name: 'Georgia (საქართველო)',
    priority: 0,
    timezone: 'Asia/Tbilisi',
  },
  GF: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '594',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GF.png',
    iso2: 'GF',
    name: 'French Guiana (Guyane française)',
    priority: 0,
    timezone: 'America/Cayenne',
  },
  GG: {
    areaCodes: null,
    currency: Currency.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GG.png',
    iso2: 'GG',
    name: 'Guernsey',
    priority: 1,
    timezone: 'Europe/Guernsey',
  },
  GH: {
    areaCodes: null,
    currency: Currency.GHS,
    dialCode: '233',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GH.png',
    iso2: 'GH',
    name: 'Ghana (Gaana)',
    priority: 0,
    timezone: 'Africa/Accra',
  },
  GI: {
    areaCodes: null,
    currency: Currency.GIP,
    dialCode: '350',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GI.png',
    iso2: 'GI',
    name: 'Gibraltar',
    priority: 0,
    timezone: 'Europe/Gibraltar',
  },
  GL: {
    areaCodes: null,
    currency: Currency.DKK,
    dialCode: '299',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GL.png',
    iso2: 'GL',
    name: 'Greenland (Kalaallit Nunaat)',
    priority: 0,
    timezone: 'America/Godthab',
  },
  GM: {
    areaCodes: null,
    currency: Currency.GMD,
    dialCode: '220',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GM.png',
    iso2: 'GM',
    name: 'Gambia',
    priority: 0,
    timezone: 'Africa/Banjul',
  },
  GN: {
    areaCodes: null,
    currency: Currency.GNF,
    dialCode: '224',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GN.png',
    iso2: 'GN',
    name: 'Guinea (Guinée)',
    priority: 0,
    timezone: 'Africa/Conakry',
  },
  GP: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GP.png',
    iso2: 'GP',
    name: 'Guadeloupe',
    priority: 0,
    timezone: 'America/Guadeloupe',
  },
  GQ: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '240',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GQ.png',
    iso2: 'GQ',
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    priority: 0,
    timezone: 'Africa/Malabo',
  },
  GR: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '30',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GR.png',
    iso2: 'GR',
    name: 'Greece (Ελλάδα)',
    priority: 0,
    timezone: 'Europe/Athens',
  },
  GT: {
    areaCodes: null,
    currency: Currency.GTQ,
    dialCode: '502',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GT.png',
    iso2: 'GT',
    name: 'Guatemala',
    priority: 0,
    timezone: 'America/Guatemala',
  },
  GU: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1671',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GU.png',
    iso2: 'GU',
    name: 'Guam',
    priority: 0,
    timezone: 'Pacific/Guam',
  },
  GW: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '245',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GW.png',
    iso2: 'GW',
    name: 'Guinea-Bissau (Guiné Bissau)',
    priority: 0,
    timezone: 'Africa/Bissau',
  },
  GY: {
    areaCodes: null,
    currency: Currency.GYD,
    dialCode: '592',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/GY.png',
    iso2: 'GY',
    name: 'Guyana',
    priority: 0,
    timezone: 'America/Guyana',
  },
  HK: {
    areaCodes: null,
    currency: Currency.HKD,
    dialCode: '852',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HK.png',
    iso2: 'HK',
    name: 'Hong Kong (香港)',
    priority: 0,
    timezone: 'Asia/Hong_Kong',
  },
  HN: {
    areaCodes: null,
    currency: Currency.HNL,
    dialCode: '504',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HN.png',
    iso2: 'HN',
    name: 'Honduras',
    priority: 0,
    timezone: 'America/Tegucigalpa',
  },
  HR: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '385',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HR.png',
    iso2: 'HR',
    name: 'Croatia (Hrvatska)',
    priority: 0,
    timezone: 'Europe/Zagreb',
  },
  HT: {
    areaCodes: null,
    currency: Currency.HTG,
    dialCode: '509',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HT.png',
    iso2: 'HT',
    name: 'Haiti',
    priority: 0,
    timezone: 'America/Port-au-Prince',
  },
  HU: {
    areaCodes: null,
    currency: Currency.HUF,
    dialCode: '36',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/HU.png',
    iso2: 'HU',
    name: 'Hungary (Magyarország)',
    priority: 0,
    timezone: 'Europe/Budapest',
  },
  ID: {
    areaCodes: null,
    currency: Currency.IDR,
    dialCode: '62',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ID.png',
    iso2: 'ID',
    name: 'Indonesia',
    priority: 0,
    timezone: 'Asia/Makassar',
  },
  IE: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '353',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IE.png',
    iso2: 'IE',
    name: 'Ireland',
    priority: 0,
    timezone: 'Europe/Dublin',
  },
  IL: {
    areaCodes: null,
    currency: Currency.ILS,
    dialCode: '972',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IL.png',
    iso2: 'IL',
    name: 'Israel (‫ישראל‬‎)',
    priority: 0,
    timezone: 'Asia/Jerusalem',
  },
  IM: {
    areaCodes: null,
    currency: Currency.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IM.png',
    iso2: 'IM',
    name: 'Isle of Man',
    priority: 2,
    timezone: 'Europe/Isle_of_Man',
  },
  IN: {
    areaCodes: null,
    currency: Currency.INR,
    dialCode: '91',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IN.png',
    iso2: 'IN',
    name: 'India (भारत)',
    priority: 0,
    timezone: 'Asia/Kolkata',
  },
  IO: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '246',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IO.png',
    iso2: 'IO',
    name: 'British Indian Ocean Territory',
    priority: 0,
    timezone: 'Etc/GMT-5',
  },
  IQ: {
    areaCodes: null,
    currency: Currency.IQD,
    dialCode: '964',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IQ.png',
    iso2: 'IQ',
    name: 'Iraq (‫العراق‬‎)',
    priority: 0,
    timezone: 'Asia/Baghdad',
  },
  IR: {
    areaCodes: null,
    currency: Currency.IRR,
    dialCode: '98',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IR.png',
    iso2: 'IR',
    name: 'Iran (‫ایران‬‎)',
    priority: 0,
    timezone: 'Asia/Tehran',
  },
  IS: {
    areaCodes: null,
    currency: Currency.ISK,
    dialCode: '354',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IS.png',
    iso2: 'IS',
    name: 'Iceland (Ísland)',
    priority: 0,
    timezone: 'Atlantic/Reykjavik',
  },
  IT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '39',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/IT.png',
    iso2: 'IT',
    name: 'Italy (Italia)',
    priority: 0,
    timezone: 'Europe/Rome',
  },
  JE: {
    areaCodes: null,
    currency: Currency.GBP,
    dialCode: '44',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JE.png',
    iso2: 'JE',
    name: 'Jersey',
    priority: 3,
    timezone: 'Europe/Jersey',
  },
  JM: {
    areaCodes: null,
    currency: Currency.JMD,
    dialCode: '1876',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JM.png',
    iso2: 'JM',
    name: 'Jamaica',
    priority: 0,
    timezone: 'America/Jamaica',
  },
  JO: {
    areaCodes: null,
    currency: Currency.JOD,
    dialCode: '962',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JO.png',
    iso2: 'JO',
    name: 'Jordan (‫الأردن‬‎)',
    priority: 0,
    timezone: 'Asia/Amman',
  },
  JP: {
    areaCodes: null,
    currency: Currency.JPY,
    dialCode: '81',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/JP.png',
    iso2: 'JP',
    name: 'Japan (日本)',
    priority: 0,
    timezone: 'Asia/Tokyo',
  },
  KE: {
    areaCodes: null,
    currency: Currency.KES,
    dialCode: '254',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KE.png',
    iso2: 'KE',
    name: 'Kenya',
    priority: 0,
    timezone: 'Africa/Nairobi',
  },
  KG: {
    areaCodes: null,
    currency: Currency.KGS,
    dialCode: '996',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KG.png',
    iso2: 'KG',
    name: 'Kyrgyzstan (Кыргызстан)',
    priority: 0,
    timezone: 'Asia/Bishkek',
  },
  KH: {
    areaCodes: null,
    currency: Currency.KHR,
    dialCode: '855',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KH.png',
    iso2: 'KH',
    name: 'Cambodia (កម្ពុជា)',
    priority: 0,
    timezone: 'Asia/Phnom_Penh',
  },
  KI: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '686',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KI.png',
    iso2: 'KI',
    name: 'Kiribati',
    priority: 0,
    timezone: 'Etc/GMT+11',
  },
  KM: {
    areaCodes: null,
    currency: Currency.KMF,
    dialCode: '269',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KM.png',
    iso2: 'KM',
    name: 'Comoros (‫جزر القمر‬‎)',
    priority: 0,
    timezone: 'Indian/Comoro',
  },
  KN: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1869',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KN.png',
    iso2: 'KN',
    name: 'Saint Kitts and Nevis',
    priority: 0,
    timezone: 'America/St_Kitts',
  },
  KP: {
    areaCodes: null,
    currency: Currency.KPW,
    dialCode: '850',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KP.png',
    iso2: 'KP',
    name: 'North Korea (조선 민주주의 인민 공화국)',
    priority: 0,
    timezone: 'Asia/Pyongyang',
  },
  KR: {
    areaCodes: null,
    currency: Currency.KRW,
    dialCode: '82',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KR.png',
    iso2: 'KR',
    name: 'South Korea (대한민국)',
    priority: 0,
    timezone: 'Asia/Seoul',
  },
  KW: {
    areaCodes: null,
    currency: Currency.KWD,
    dialCode: '965',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KW.png',
    iso2: 'KW',
    name: 'Kuwait (‫الكويت‬‎)',
    priority: 0,
    timezone: 'Asia/Kuwait',
  },
  KY: {
    areaCodes: null,
    currency: Currency.KYD,
    dialCode: '1345',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KY.png',
    iso2: 'KY',
    name: 'Cayman Islands',
    priority: 0,
    timezone: 'Etc/GMT+5',
  },
  KZ: {
    areaCodes: null,
    currency: Currency.KZT,
    dialCode: '7',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/KZ.png',
    iso2: 'KZ',
    name: 'Kazakhstan (Казахстан)',
    priority: 1,
    timezone: 'Asia/Almaty',
  },
  LA: {
    areaCodes: null,
    currency: Currency.LAK,
    dialCode: '856',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LA.png',
    iso2: 'LA',
    name: 'Laos (ລາວ)',
    priority: 0,
    timezone: 'Asia/Vientiane',
  },
  LB: {
    areaCodes: null,
    currency: Currency.LBP,
    dialCode: '961',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LB.png',
    iso2: 'LB',
    name: 'Lebanon (‫لبنان‬‎)',
    priority: 0,
    timezone: 'Asia/Beirut',
  },
  LC: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1758',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LC.png',
    iso2: 'LC',
    name: 'Saint Lucia',
    priority: 0,
    timezone: 'America/St_Lucia',
  },
  LI: {
    areaCodes: null,
    currency: Currency.CHF,
    dialCode: '423',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LI.png',
    iso2: 'LI',
    name: 'Liechtenstein',
    priority: 0,
    timezone: 'Europe/Vaduz',
  },
  LK: {
    areaCodes: null,
    currency: Currency.LKR,
    dialCode: '94',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LK.png',
    iso2: 'LK',
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    priority: 0,
    timezone: 'Asia/Colombo',
  },
  LR: {
    areaCodes: null,
    currency: Currency.LRD,
    dialCode: '231',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LR.png',
    iso2: 'LR',
    name: 'Liberia',
    priority: 0,
    timezone: 'Africa/Monrovia',
  },
  LS: {
    areaCodes: null,
    currency: Currency.LSL,
    dialCode: '266',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LS.png',
    iso2: 'LS',
    name: 'Lesotho',
    priority: 0,
    timezone: 'Africa/Maseru',
  },
  LT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '370',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LT.png',
    iso2: 'LT',
    name: 'Lithuania (Lietuva)',
    priority: 0,
    timezone: 'Europe/Vilnius',
  },
  LU: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '352',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LU.png',
    iso2: 'LU',
    name: 'Luxembourg',
    priority: 0,
    timezone: 'Europe/Luxembourg',
  },
  LV: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '371',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LV.png',
    iso2: 'LV',
    name: 'Latvia (Latvija)',
    priority: 0,
    timezone: 'Europe/Riga',
  },
  LY: {
    areaCodes: null,
    currency: Currency.LYD,
    dialCode: '218',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/LY.png',
    iso2: 'LY',
    name: 'Libya (‫ليبيا‬‎)',
    priority: 0,
    timezone: 'Africa/Tripoli',
  },
  MA: {
    areaCodes: null,
    currency: Currency.MAD,
    dialCode: '212',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MA.png',
    iso2: 'MA',
    name: 'Morocco (‫المغرب‬‎)',
    priority: 0,
    timezone: 'Africa/Casablanca',
  },
  MC: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '377',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MC.png',
    iso2: 'MC',
    name: 'Monaco',
    priority: 0,
    timezone: 'Europe/Paris',
  },
  MD: {
    areaCodes: null,
    currency: Currency.MDL,
    dialCode: '373',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MD.png',
    iso2: 'MD',
    name: 'Moldova (Republica Moldova)',
    priority: 0,
    timezone: 'Europe/Chisinau',
  },
  ME: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '382',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ME.png',
    iso2: 'ME',
    name: 'Montenegro (Crna Gora)',
    priority: 0,
    timezone: 'Europe/Podgorica',
  },
  MF: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '590',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MF.png',
    iso2: 'MF',
    name: 'Saint Martin (Saint-Martin (partie française))',
    priority: 2,
    timezone: 'America/Marigot',
  },
  MG: {
    areaCodes: null,
    currency: Currency.MGA,
    dialCode: '261',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MG.png',
    iso2: 'MG',
    name: 'Madagascar (Madagasikara)',
    priority: 0,
    timezone: 'Indian/Antananarivo',
  },
  MH: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '692',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MH.png',
    iso2: 'MH',
    name: 'Marshall Islands',
    priority: 0,
    timezone: 'Etc/GMT-11',
  },
  MK: {
    areaCodes: null,
    currency: Currency.MKD,
    dialCode: '389',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MK.png',
    iso2: 'MK',
    name: 'Macedonia (FYROM) (Македонија)',
    priority: 0,
    timezone: 'Europe/Skopje',
  },
  ML: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '223',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ML.png',
    iso2: 'ML',
    name: 'Mali',
    priority: 0,
    timezone: 'Africa/Bamako',
  },
  MM: {
    areaCodes: null,
    currency: Currency.MMK,
    dialCode: '95',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MM.png',
    iso2: 'MM',
    name: 'Myanmar (Burma) (မြန်မာ)',
    priority: 0,
    timezone: 'Asia/Yangon',
  },
  MN: {
    areaCodes: null,
    currency: Currency.MNT,
    dialCode: '976',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MN.png',
    iso2: 'MN',
    name: 'Mongolia (Монгол)',
    priority: 0,
    timezone: 'Asia/Ulaanbaatar',
  },
  MO: {
    areaCodes: null,
    currency: Currency.MOP,
    dialCode: '853',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MO.png',
    iso2: 'MO',
    name: 'Macau (澳門)',
    priority: 0,
    timezone: 'Asia/Macau',
  },
  MP: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1670',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MP.png',
    iso2: 'MP',
    name: 'Northern Mariana Islands',
    priority: 0,
    timezone: 'Pacific/Saipan',
  },
  MQ: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '596',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MQ.png',
    iso2: 'MQ',
    name: 'Martinique',
    priority: 0,
    timezone: 'America/Martinique',
  },
  MR: {
    areaCodes: null,
    currency: Currency.MRU,
    dialCode: '222',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MR.png',
    iso2: 'MR',
    name: 'Mauritania (‫موريتانيا‬‎)',
    priority: 0,
    timezone: 'Africa/Nouakchott',
  },
  MS: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1664',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MS.png',
    iso2: 'MS',
    name: 'Montserrat',
    priority: 0,
    timezone: 'America/Montserrat',
  },
  MT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '356',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MT.png',
    iso2: 'MT',
    name: 'Malta',
    priority: 0,
    timezone: 'Europe/Malta',
  },
  MU: {
    areaCodes: null,
    currency: Currency.MUR,
    dialCode: '230',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MU.png',
    iso2: 'MU',
    name: 'Mauritius (Moris)',
    priority: 0,
    timezone: 'Indian/Mauritius',
  },
  MV: {
    areaCodes: null,
    currency: Currency.MVR,
    dialCode: '960',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MV.png',
    iso2: 'MV',
    name: 'Maldives',
    priority: 0,
    timezone: 'Indian/Maldives',
  },
  MW: {
    areaCodes: null,
    currency: Currency.MWK,
    dialCode: '265',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MW.png',
    iso2: 'MW',
    name: 'Malawi',
    priority: 0,
    timezone: 'Africa/Blantyre',
  },
  MX: {
    areaCodes: null,
    currency: Currency.MXN,
    dialCode: '52',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MX.png',
    iso2: 'MX',
    name: 'Mexico (México)',
    priority: 0,
    timezone: 'America/Mexico_City',
  },
  MY: {
    areaCodes: null,
    currency: Currency.MYR,
    dialCode: '60',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MY.png',
    iso2: 'MY',
    name: 'Malaysia',
    priority: 0,
    timezone: 'Asia/Kuching',
  },
  MZ: {
    areaCodes: null,
    currency: Currency.MZN,
    dialCode: '258',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/MZ.png',
    iso2: 'MZ',
    name: 'Mozambique (Moçambique)',
    priority: 0,
    timezone: 'Africa/Maputo',
  },
  NA: {
    areaCodes: null,
    currency: Currency.NAD,
    dialCode: '264',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NA.png',
    iso2: 'NA',
    name: 'Namibia (Namibië)',
    priority: 0,
    timezone: 'Africa/Windhoek',
  },
  NC: {
    areaCodes: null,
    currency: Currency.XPF,
    dialCode: '687',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NC.png',
    iso2: 'NC',
    name: 'New Caledonia (Nouvelle-Calédonie)',
    priority: 0,
    timezone: 'Pacific/Noumea',
  },
  NE: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '227',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NE.png',
    iso2: 'NE',
    name: 'Niger (Nijar)',
    priority: 0,
    timezone: 'Africa/Niamey',
  },
  NF: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '672',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NF.png',
    iso2: 'NF',
    name: 'Norfolk Island',
    priority: 0,
    timezone: 'Pacific/Norfolk',
  },
  NG: {
    areaCodes: null,
    currency: Currency.NGN,
    dialCode: '234',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NG.png',
    iso2: 'NG',
    name: 'Nigeria',
    priority: 0,
    timezone: 'Africa/Lagos',
  },
  NI: {
    areaCodes: null,
    currency: Currency.NIO,
    dialCode: '505',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NI.png',
    iso2: 'NI',
    name: 'Nicaragua',
    priority: 0,
    timezone: 'America/Managua',
  },
  NL: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '31',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NL.png',
    iso2: 'NL',
    name: 'Netherlands (Nederland)',
    priority: 0,
    timezone: 'Europe/Amsterdam',
  },
  NO: {
    areaCodes: null,
    currency: Currency.NOK,
    dialCode: '47',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NO.png',
    iso2: 'NO',
    name: 'Norway (Norge)',
    priority: 0,
    timezone: 'Europe/Oslo',
  },
  NP: {
    areaCodes: null,
    currency: Currency.NPR,
    dialCode: '977',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NP.png',
    iso2: 'NP',
    name: 'Nepal (नेपाल)',
    priority: 0,
    timezone: 'Asia/Kathmandu',
  },
  NR: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '674',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NR.png',
    iso2: 'NR',
    name: 'Nauru',
    priority: 0,
    timezone: 'Pacific/Nauru',
  },
  NU: {
    areaCodes: null,
    currency: Currency.NZD,
    dialCode: '683',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NU.png',
    iso2: 'NU',
    name: 'Niue',
    priority: 0,
    timezone: 'Pacific/Niue',
  },
  NZ: {
    areaCodes: null,
    currency: Currency.NZD,
    dialCode: '64',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/NZ.png',
    iso2: 'NZ',
    name: 'New Zealand',
    priority: 0,
    timezone: 'Pacific/Auckland',
  },
  OM: {
    areaCodes: null,
    currency: Currency.OMR,
    dialCode: '968',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/OM.png',
    iso2: 'OM',
    name: 'Oman (‫عُمان‬‎)',
    priority: 0,
    timezone: 'Asia/Muscat',
  },
  PA: {
    areaCodes: null,
    currency: Currency.PAB,
    dialCode: '507',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PA.png',
    iso2: 'PA',
    name: 'Panama (Panamá)',
    priority: 0,
    timezone: 'America/Panama',
  },
  PE: {
    areaCodes: null,
    currency: Currency.PEN,
    dialCode: '51',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PE.png',
    iso2: 'PE',
    name: 'Peru (Perú)',
    priority: 0,
    timezone: 'America/Lima',
  },
  PF: {
    areaCodes: null,
    currency: Currency.XPF,
    dialCode: '689',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PF.png',
    iso2: 'PF',
    name: 'French Polynesia (Polynésie française)',
    priority: 0,
    timezone: 'Etc/GMT+9',
  },
  PG: {
    areaCodes: null,
    currency: Currency.PGK,
    dialCode: '675',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PG.png',
    iso2: 'PG',
    name: 'Papua New Guinea',
    priority: 0,
    timezone: 'Pacific/Port_Moresby',
  },
  PH: {
    areaCodes: null,
    currency: Currency.PHP,
    dialCode: '63',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PH.png',
    iso2: 'PH',
    name: 'Philippines',
    priority: 0,
    timezone: 'Asia/Manila',
  },
  PK: {
    areaCodes: null,
    currency: Currency.PKR,
    dialCode: '92',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PK.png',
    iso2: 'PK',
    name: 'Pakistan (‫پاکستان‬‎)',
    priority: 0,
    timezone: 'Asia/Karachi',
  },
  PL: {
    areaCodes: null,
    currency: Currency.PLN,
    dialCode: '48',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PL.png',
    iso2: 'PL',
    name: 'Poland (Polska)',
    priority: 0,
    timezone: 'Europe/Warsaw',
  },
  PM: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '508',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PM.png',
    iso2: 'PM',
    name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    priority: 0,
    timezone: 'America/Miquelon',
  },
  PR: {
    areaCodes: ['787', '939'],
    currency: Currency.USD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PR.png',
    iso2: 'PR',
    name: 'Puerto Rico',
    priority: 3,
    timezone: 'America/Puerto_Rico',
  },
  PS: {
    areaCodes: null,
    currency: Currency.ILS,
    dialCode: '970',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PS.png',
    iso2: 'PS',
    name: 'Palestine (‫فلسطين‬‎)',
    priority: 0,
    timezone: 'Asia/Jerusalem',
  },
  PT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '351',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PT.png',
    iso2: 'PT',
    name: 'Portugal',
    priority: 0,
    timezone: 'Europe/Lisbon',
  },
  PW: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '680',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PW.png',
    iso2: 'PW',
    name: 'Palau',
    priority: 0,
    timezone: 'Etc/GMT-9',
  },
  PY: {
    areaCodes: null,
    currency: Currency.PYG,
    dialCode: '595',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/PY.png',
    iso2: 'PY',
    name: 'Paraguay',
    priority: 0,
    timezone: 'America/Asuncion',
  },
  QA: {
    areaCodes: null,
    currency: Currency.QAR,
    dialCode: '974',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/QA.png',
    iso2: 'QA',
    name: 'Qatar (‫قطر‬‎)',
    priority: 0,
    timezone: 'Asia/Qatar',
  },
  RE: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '262',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RE.png',
    iso2: 'RE',
    name: 'Réunion (La Réunion)',
    priority: 0,
    timezone: 'Indian/Reunion',
  },
  RO: {
    areaCodes: null,
    currency: Currency.RON,
    dialCode: '40',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RO.png',
    iso2: 'RO',
    name: 'Romania (România)',
    priority: 0,
    timezone: 'Europe/Bucharest',
  },
  RS: {
    areaCodes: null,
    currency: Currency.RSD,
    dialCode: '381',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RS.png',
    iso2: 'RS',
    name: 'Serbia (Србија)',
    priority: 0,
    timezone: 'Europe/Belgrade',
  },
  RU: {
    areaCodes: null,
    currency: Currency.RUB,
    dialCode: '7',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RU.png',
    iso2: 'RU',
    name: 'Russia (Россия)',
    priority: 0,
    timezone: 'Asia/Krasnoyarsk',
  },
  RW: {
    areaCodes: null,
    currency: Currency.RWF,
    dialCode: '250',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/RW.png',
    iso2: 'RW',
    name: 'Rwanda',
    priority: 0,
    timezone: 'Africa/Kigali',
  },
  SA: {
    areaCodes: null,
    currency: Currency.SAR,
    dialCode: '966',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SA.png',
    iso2: 'SA',
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    priority: 0,
    timezone: 'Asia/Riyadh',
  },
  SB: {
    areaCodes: null,
    currency: Currency.SBD,
    dialCode: '677',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SB.png',
    iso2: 'SB',
    name: 'Solomon Islands',
    priority: 0,
    timezone: 'Pacific/Guadalcanal',
  },
  SC: {
    areaCodes: null,
    currency: Currency.SCR,
    dialCode: '248',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SC.png',
    iso2: 'SC',
    name: 'Seychelles',
    priority: 0,
    timezone: 'Indian/Mahe',
  },
  SD: {
    areaCodes: null,
    currency: Currency.SDG,
    dialCode: '249',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SD.png',
    iso2: 'SD',
    name: 'Sudan (‫السودان‬‎)',
    priority: 0,
    timezone: 'Africa/Khartoum',
  },
  SE: {
    areaCodes: null,
    currency: Currency.SEK,
    dialCode: '46',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SE.png',
    iso2: 'SE',
    name: 'Sweden (Sverige)',
    priority: 0,
    timezone: 'Europe/Stockholm',
  },
  SG: {
    areaCodes: null,
    currency: Currency.SGD,
    dialCode: '65',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SG.png',
    iso2: 'SG',
    name: 'Singapore',
    priority: 0,
    timezone: 'Asia/Singapore',
  },
  SH: {
    areaCodes: null,
    currency: Currency.SHP,
    dialCode: '290',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SH.png',
    iso2: 'SH',
    name: 'Saint Helena',
    priority: 0,
    timezone: 'Atlantic/St_Helena',
  },
  SI: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '386',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SI.png',
    iso2: 'SI',
    name: 'Slovenia (Slovenija)',
    priority: 0,
    timezone: 'Europe/Ljubljana',
  },
  SJ: {
    areaCodes: null,
    currency: Currency.NOK,
    dialCode: '47',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SJ.png',
    iso2: 'SJ',
    name: 'Svalbard and Jan Mayen',
    priority: 1,
    timezone: 'Arctic/Longyearbyen',
  },
  SK: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '421',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SK.png',
    iso2: 'SK',
    name: 'Slovakia (Slovensko)',
    priority: 0,
    timezone: 'Europe/Bratislava',
  },
  SL: {
    areaCodes: null,
    currency: Currency.SLL,
    dialCode: '232',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SL.png',
    iso2: 'SL',
    name: 'Sierra Leone',
    priority: 0,
    timezone: 'Africa/Freetown',
  },
  SM: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '378',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SM.png',
    iso2: 'SM',
    name: 'San Marino',
    priority: 0,
    timezone: 'Europe/San_Marino',
  },
  SN: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '221',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SN.png',
    iso2: 'SN',
    name: 'Senegal (Sénégal)',
    priority: 0,
    timezone: 'Africa/Dakar',
  },
  SO: {
    areaCodes: null,
    currency: Currency.SOS,
    dialCode: '252',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SO.png',
    iso2: 'SO',
    name: 'Somalia (Soomaaliya)',
    priority: 0,
    timezone: 'Africa/Mogadishu',
  },
  SR: {
    areaCodes: null,
    currency: Currency.SRD,
    dialCode: '597',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SR.png',
    iso2: 'SR',
    name: 'Suriname',
    priority: 0,
    timezone: 'America/Paramaribo',
  },
  SS: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '211',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SS.png',
    iso2: 'SS',
    name: 'South Sudan (‫جنوب السودان‬‎)',
    priority: 0,
    timezone: 'Africa/Juba',
  },
  ST: {
    areaCodes: null,
    currency: Currency.STD,
    dialCode: '239',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ST.png',
    iso2: 'ST',
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    priority: 0,
    timezone: 'Africa/Sao_Tome',
  },
  SV: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '503',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SV.png',
    iso2: 'SV',
    name: 'El Salvador',
    priority: 0,
    timezone: 'America/El_Salvador',
  },
  SX: {
    areaCodes: null,
    currency: Currency.ANG,
    dialCode: '1721',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SX.png',
    iso2: 'SX',
    name: 'Sint Maarten',
    priority: 0,
    timezone: 'America/Lower_Princes',
  },
  SY: {
    areaCodes: null,
    currency: Currency.SYP,
    dialCode: '963',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SY.png',
    iso2: 'SY',
    name: 'Syria (‫سوريا‬‎)',
    priority: 0,
    timezone: 'Asia/Damascus',
  },
  SZ: {
    areaCodes: null,
    currency: Currency.SZL,
    dialCode: '268',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/SZ.png',
    iso2: 'SZ',
    name: 'Swaziland',
    priority: 0,
    timezone: 'Africa/Mbabane',
  },
  TC: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1649',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TC.png',
    iso2: 'TC',
    name: 'Turks and Caicos Islands',
    priority: 0,
    timezone: 'America/Grand_Turk',
  },
  TD: {
    areaCodes: null,
    currency: Currency.XAF,
    dialCode: '235',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TD.png',
    iso2: 'TD',
    name: 'Chad (Tchad)',
    priority: 0,
    timezone: 'Africa/Ndjamena',
  },
  TG: {
    areaCodes: null,
    currency: Currency.XOF,
    dialCode: '228',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TG.png',
    iso2: 'TG',
    name: 'Togo',
    priority: 0,
    timezone: 'Africa/Lome',
  },
  TH: {
    areaCodes: null,
    currency: Currency.THB,
    dialCode: '66',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TH.png',
    iso2: 'TH',
    name: 'Thailand (ไทย)',
    priority: 0,
    timezone: 'Asia/Bangkok',
  },
  TJ: {
    areaCodes: null,
    currency: Currency.TJS,
    dialCode: '992',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TJ.png',
    iso2: 'TJ',
    name: 'Tajikistan',
    priority: 0,
    timezone: 'Asia/Dushanbe',
  },
  TK: {
    areaCodes: null,
    currency: Currency.NZD,
    dialCode: '690',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TK.png',
    iso2: 'TK',
    name: 'Tokelau',
    priority: 0,
    timezone: 'Pacific/Fakaofo',
  },
  TL: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '670',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TL.png',
    iso2: 'TL',
    name: 'Timor-Leste',
    priority: 0,
    timezone: 'Asia/Dili',
  },
  TM: {
    areaCodes: null,
    currency: Currency.TMT,
    dialCode: '993',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TM.png',
    iso2: 'TM',
    name: 'Turkmenistan',
    priority: 0,
    timezone: 'Asia/Ashgabat',
  },
  TN: {
    areaCodes: null,
    currency: Currency.TND,
    dialCode: '216',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TN.png',
    iso2: 'TN',
    name: 'Tunisia (‫تونس‬‎)',
    priority: 0,
    timezone: 'Africa/Tunis',
  },
  TO: {
    areaCodes: null,
    currency: Currency.TOP,
    dialCode: '676',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TO.png',
    iso2: 'TO',
    name: 'Tonga',
    priority: 0,
    timezone: 'Pacific/Tongatapu',
  },
  TR: {
    areaCodes: null,
    currency: Currency.TRY,
    dialCode: '90',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TR.png',
    iso2: 'TR',
    name: 'Turkey (Türkiye)',
    priority: 0,
    timezone: 'Europe/Istanbul',
  },
  TT: {
    areaCodes: null,
    currency: Currency.TTD,
    dialCode: '1868',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TT.png',
    iso2: 'TT',
    name: 'Trinidad and Tobago',
    priority: 0,
    timezone: 'America/Port_of_Spain',
  },
  TV: {
    areaCodes: null,
    currency: Currency.AUD,
    dialCode: '688',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TV.png',
    iso2: 'TV',
    name: 'Tuvalu',
    priority: 0,
    timezone: 'Etc/GMT-12',
  },
  TW: {
    areaCodes: null,
    currency: Currency.TWD,
    dialCode: '886',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TW.png',
    iso2: 'TW',
    name: 'Taiwan (台灣)',
    priority: 0,
    timezone: 'Asia/Taipei',
  },
  TZ: {
    areaCodes: null,
    currency: Currency.TZS,
    dialCode: '255',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/TZ.png',
    iso2: 'TZ',
    name: 'Tanzania',
    priority: 0,
    timezone: 'Africa/Dar_es_Salaam',
  },
  UA: {
    areaCodes: null,
    currency: Currency.UAH,
    dialCode: '380',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UA.png',
    iso2: 'UA',
    name: 'Ukraine (Україна)',
    priority: 0,
    timezone: 'Europe/Kiev',
  },
  UG: {
    areaCodes: null,
    currency: Currency.UGX,
    dialCode: '256',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UG.png',
    iso2: 'UG',
    name: 'Uganda',
    priority: 0,
    timezone: 'Africa/Kampala',
  },
  US: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/US.png',
    iso2: 'US',
    name: 'United States',
    priority: 0,
    timezone: 'America/Chicago',
  },
  UY: {
    areaCodes: null,
    currency: Currency.UYU,
    dialCode: '598',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UY.png',
    iso2: 'UY',
    name: 'Uruguay',
    priority: 0,
    timezone: 'America/Montevideo',
  },
  UZ: {
    areaCodes: null,
    currency: Currency.UZS,
    dialCode: '998',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/UZ.png',
    iso2: 'UZ',
    name: 'Uzbekistan (Oʻzbekiston)',
    priority: 0,
    timezone: 'Asia/Samarkand',
  },
  VA: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '39',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VA.png',
    iso2: 'VA',
    name: 'Vatican City (Città del Vaticano)',
    priority: 1,
    timezone: 'Europe/Rome',
  },
  VC: {
    areaCodes: null,
    currency: Currency.XCD,
    dialCode: '1784',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VC.png',
    iso2: 'VC',
    name: 'Saint Vincent and the Grenadines',
    priority: 0,
    timezone: 'America/St_Vincent',
  },
  VE: {
    areaCodes: null,
    currency: Currency.VES,
    dialCode: '58',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VE.png',
    iso2: 'VE',
    name: 'Venezuela',
    priority: 0,
    timezone: 'America/Caracas',
  },
  VG: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1284',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VG.png',
    iso2: 'VG',
    name: 'British Virgin Islands',
    priority: 0,
    timezone: 'America/Tortola',
  },
  VI: {
    areaCodes: null,
    currency: Currency.USD,
    dialCode: '1340',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VI.png',
    iso2: 'VI',
    name: 'U.S. Virgin Islands',
    priority: 0,
    timezone: 'America/St_Thomas',
  },
  VN: {
    areaCodes: null,
    currency: Currency.VND,
    dialCode: '84',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VN.png',
    iso2: 'VN',
    name: 'Vietnam (Việt Nam)',
    priority: 0,
    timezone: 'Asia/Ho_Chi_Minh',
  },
  VU: {
    areaCodes: null,
    currency: Currency.VUV,
    dialCode: '678',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/VU.png',
    iso2: 'VU',
    name: 'Vanuatu',
    priority: 0,
    timezone: 'Pacific/Efate',
  },
  WF: {
    areaCodes: null,
    currency: Currency.XPF,
    dialCode: '681',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WF.png',
    iso2: 'WF',
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    priority: 0,
    timezone: 'Pacific/Wallis',
  },
  WS: {
    areaCodes: null,
    currency: Currency.WST,
    dialCode: '685',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/WS.png',
    iso2: 'WS',
    name: 'Samoa',
    priority: 0,
    timezone: 'Pacific/Apia',
  },
  XK: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '383',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/XK.png',
    iso2: 'XK',
    name: 'Kosovo',
    priority: 0,
    timezone: 'Europe/Rome',
  },
  YE: {
    areaCodes: null,
    currency: Currency.YER,
    dialCode: '967',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YE.png',
    iso2: 'YE',
    name: 'Yemen (‫اليمن‬‎)',
    priority: 0,
    timezone: 'Asia/Aden',
  },
  YT: {
    areaCodes: null,
    currency: Currency.EUR,
    dialCode: '262',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/YT.png',
    iso2: 'YT',
    name: 'Mayotte',
    priority: 1,
    timezone: 'Indian/Mayotte',
  },
  ZA: {
    areaCodes: null,
    currency: Currency.ZAR,
    dialCode: '27',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZA.png',
    iso2: 'ZA',
    name: 'South Africa',
    priority: 0,
    timezone: 'Africa/Johannesburg',
  },
  ZM: {
    areaCodes: null,
    currency: Currency.ZMK,
    dialCode: '260',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZM.png',
    iso2: 'ZM',
    name: 'Zambia',
    priority: 0,
    timezone: 'Africa/Lusaka',
  },
  ZW: {
    areaCodes: null,
    currency: Currency.ZWL,
    dialCode: '263',
    icon: 'https://raw.githubusercontent.com/behdad/region-flags/gh-pages/png/ZW.png',
    iso2: 'ZW',
    name: 'Zimbabwe',
    priority: 0,
    timezone: 'Africa/Harare',
  },
}
/* eslint-enable max-lines */

export const ISO_COUNTRIES = Object.values(COUNTRIES).map(
  country => country.iso2,
)
